
import axios from 'axios';
import authHeader from './auth-header'; // Asegúrate de que esto esté configurado

const API_URL = process.env.VUE_APP_API_BASE_URL;

export default {
    getAll(pageUrl = null) {
        const url = `${API_URL}/bodegas?page=${pageUrl}`;
        return axios.get(url, { headers: authHeader() });
    },
    getData(id) {
        return axios.get(`${API_URL}/bodegas/${id}`, { headers: authHeader() });
    },
    createData(data) {
        return axios.post(`${API_URL}/bodegas`, data, { headers: authHeader() });
    },
    updateData(id, data) {
        return axios.put(`${API_URL}/bodegas/${id}`, data, { headers: authHeader() });
    },
    deleteData(id) {
        return axios.delete(`${API_URL}/bodegas/${id}`, { headers: authHeader() });
    },

};